<template>
    <a-drawer
        :title="form.getFieldValue('customid') ? $t('program.edit_unit' /* 编辑单元 */) : $t('program.add_academic_unit' /* 添加学术单元 */)"
        width="700"
        placement="right"
        :closable="true"
        :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
        :visible="visible"
        @close="handleDrawerClose"
    >
        <!-- 解决不置顶问题 -->
        <a-form :style="{ height: visible ? 'auto' : '0' }" class="session-form" :form="form">
            <a-row :gutter="[10, 0]">
                <a-col :xs="24" :sm="12">
                    <a-form-item class="mb0" label="">
                        <a-input type="hidden" v-decorator="['customid']" />
                    </a-form-item>
                    <a-form-item class="mb10" :label="$t('program.batch_live_label_date' /* 日期 */)">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date' /* 日期 */)"
                            v-decorator="['date_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date' /* 日期 */) }] }]"
                        >
                            <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                                {{ item.meeting_date }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item class="mb10" :label="$t('program.batch_live_label_hall' /* 会场 */)">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall' /* 会场 */)"
                            v-decorator="['hall_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall' /* 会场 */) }] }]"
                        >
                            <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                                {{ item.meeting_hall }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" v-if="xuezuList.length" :label="$t('program.label_xuezu' /* 分论坛 */)">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.label_xuezu' /* 分论坛 */)"
                            allowClear
                            v-decorator="['xuezu_id', { rules: [{ required: false, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.label_xuezu' /* 分论坛 */) }] }]"
                        >
                            <a-select-option v-for="item in xuezuList" :key="item.id" :value="item.id">
                                {{ item.class_cnname }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item class="mb10" v-if="enuInfo.activity_list?.length" :label="$t('program.activity' /* 活动 */)">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.activity' /* 活动 */)"
                            v-decorator="['activity_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.activity' /* 活动 */) }] }]"
                        >
                            <a-select-option v-for="item in enuInfo.activity_list" :key="item.id" :value="item.id">
                                {{ item.cn_title }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="14">
                    <a-form-item :required="true" class="mb0" :label="$t('program.time_period' /* 时段 */)"></a-form-item>
                    <div class="flex x-left y-center">
                        <a-form-item class="mb10 flex-item">
                            <a-time-picker
                                style="width: 100%"
                                :placeholder="$t('program.start_time_placeholder' /* 开始时间 */)"
                                v-decorator="['starttime_slot', { rules: [{ required: true, message: $t('program.start_time_placeholder' /* 开始时间 */) }] }]"
                                @change="handleStartTimeChange"
                                format="HH:mm"
                            />
                        </a-form-item>
                        <span class="ml10 mr10 mb10">-</span>
                        <a-form-item class="mb10 flex-item">
                            <a-time-picker
                                style="width: 100%"
                                :placeholder="$t('program.end_time_placeholder' /* 结束时间 */)"
                                v-decorator="['endtime_slot', { rules: [{ required: true, message: $t('program.end_time_placeholder' /* 结束时间 */) }] }]"
                                @change="handleEndTimeChange"
                                :disabledHours="disabledHours"
                                :disabledMinutes="disabledMinutes"
                                format="HH:mm"
                            />
                        </a-form-item>
                    </div>
                </a-col>
                <a-col :xs="24" :sm="10">
                    <a-form-item class="mb10" :label="$t('program.single_schedule_duration' /* 单条日程时长(分钟） */)">
                        <a-input-number
                            :placeholder="$t('program.single_schedule_duration' /* 单条日程时长(分钟） */)"
                            style="width: 100%"
                            step="1"
                            :min="0"
                            @change="handleTimeLongChange"
                            v-decorator="['timelength', { rules: [{ required: true, message: $t('program.single_schedule_duration' /* 单条日程时长(分钟） */) }] }]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.sorting' /* 排序 */)">
                        <a-input-number style="width: 100%" name="is_fy_type" step="1" v-decorator="['orderbyid', { rules: [{ required: true, message: $t('program.sorting' /* 排序 */) }] }]" />
                        <p slot="extra" class="error-color mb10">{{ $t('program.sorting_tip' /* 序号越小越靠前 */) }}</p>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10">
                        <a-checkbox v-decorator="['is_change_timelength', { valuePropName: 'checked' }]">{{ $t('program.change_single_schedule_duration' /* 是否变更单条日程时长 */) }}</a-checkbox>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item class="mb10" :label="$t('program.unit_chinese_title' /* 单元中文标题 */)">
                        <a-input v-decorator="['abstract_title']" />
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item class="mb10" :label="$t('program.unit_english_title' /* 单元英文标题 */)">
                        <a-input v-decorator="['abstract_title_en']" />
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.hall_type' /* 会场类型 */)">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.hall_type' /* 会场类型 */)"
                            v-decorator="[
                                'hall_language',
                                {
                                    initialValue: $route.params.lang == 'cn' ? '1' : '2',
                                    rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.hall_type' /* 会场类型 */) }]
                                }
                            ]"
                        >
                            <a-select-option value="1">{{ $t('program.chinese_hall' /* 中文会场 */) }}</a-select-option>
                            <a-select-option value="2">{{ $t('program.english_hall' /* 英文会场 */) }}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.session_introduction_cn' /* session简介中文 */)">
                        <tinymceEditor v-decorator="['session_introduction']" :type="2" :height="300"></tinymceEditor>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.session_introduction_en' /* session简介英文 */)">
                        <tinymceEditor v-decorator="['session_introduction_en']" :type="2" :height="300"></tinymceEditor>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.cn_website_display_mode' /* 中文网站显示方式 */)">
                        <a-radio-group v-decorator="['display_cnmode', { initialValue: '0' }]">
                            <a-radio-button v-for="it in display_mode" :key="it.value" :value="it.value">
                                {{ it.label }}
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.en_website_display_mode' /* 英文网站显示方式 */)">
                        <a-radio-group v-decorator="['display_enmode', { initialValue: '0' }]">
                            <a-radio-button v-for="it in display_mode" :key="it.value" :value="it.value">
                                {{ it.label }}
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item class="mb10" :label="$t('program.unit_color' /* 单元颜色 */)">
                        <colorSelect :size="35" v-decorator="['colour']" />
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item :label="$t('program.is_satellite' /* 是否是专题会 */)" class="mb10">
                        <a-switch
                            v-decorator="['is_satellite', { valuePropName: 'checked', initialValue: false }]"
                            :checked-children="$t('formConfig.yes' /* 是 */)"
                            :un-checked-children="$t('formConfig.no' /* 否 */)"
                        />
                        <p slot="extra" class="error-color mb10">{{ $t('program.is_satellite_tip' /* 开启后可在直播页面专题会tab展示 */) }}</p>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item :label="$t('program.is_sync_program' /* 是否同步到现场日程 */)" class="mb10">
                        <a-switch
                            v-decorator="['is_sync_program', { valuePropName: 'checked', initialValue: false }]"
                            :checked-children="$t('formConfig.yes' /* 是 */)"
                            :un-checked-children="$t('formConfig.no' /* 否 */)"
                        />
                        <p slot="extra" class="error-color mb10">{{ $t('program.is_sync_program_tip' /* 关闭后不同步到幻灯系统 */) }}</p>
                    </a-form-item>
                </a-col>
                <a-col v-if="form.getFieldValue('is_satellite')" :xs="24">
                    <a-form-item :label="$t('program.associated_exhibitor' /* 关联展商 */)" class="mb10">
                        <a-select v-decorator="['team_id', { rules: [{ required: true, message: $t('program.associated_exhibitor' /* 关联展商 */) }] }]">
                            <a-select-option v-for="it in enuInfo.team_list" :key="it.id" :value="it.id">
                                {{ it.team_name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :xs="24">
                    <a-form-item :label="$t('program.live_source' /* 直播来源 */)" class="mb10">
                        <a-select v-decorator="['live_source', { initialValue: '0', rules: [{ required: true, message: $t('program.live_source' /* 直播来源 */) }] }]">
                            <a-select-option v-for="it in live_source" :key="it.value" :value="it.value">
                                {{ it.label }}
                            </a-select-option>
                        </a-select>
                        <div slot="extra" class="error-color">
                            <p class="mb5">{{ $t('program.live_source_tip' /* 控制日程页面观看直播按钮的显示 */) }}</p>
                            <p class="mb5">{{ $t('program.default_hall_config' /* 默认会场配置：调用会场关联的直播 */) }}</p>
                            <p class="mb5">{{ $t('program.system_table_live' /* 系统表直播：选择关联调用系统直播 */) }}</p>
                            <p>{{ $t('program.third_party_live' /* 第三方平台直播：填写第三方平台链接调用跳转第三方平台地址 */) }}</p>
                        </div>
                    </a-form-item>
                </a-col>

                <a-col v-if="form.getFieldValue('live_source') == 1" :xs="24">
                    <a-form-item :label="$t('program.select_associated_live' /* 选择关联直播 */)" class="mb10">
                        <a-select optionFilterProp="name" show-search v-decorator="['live_id', { rules: [{ required: true, message: $t('program.select_associated_live' /* 选择关联直播 */) }] }]">
                            <a-select-option v-for="it in enuInfo.live_list" :name="it.id + '-' + it.title" :key="it.id" :value="it.id">{{ it.id }} - {{ it.title }}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>

                <a-col v-if="form.getFieldValue('live_source') == 2" :xs="24">
                    <a-form-item :label="$t('program.live_url' /* 直播链接 */)" class="mb10">
                        <a-input
                            :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('program.live_url' /* 直播链接 */)"
                            v-decorator="['live_url', { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('program.live_url' /* 直播链接 */) }] }]"
                        />
                    </a-form-item>
                </a-col>

                <a-col :xs="24">
                    <a-form-item :label="$t('program.batch_live_label_live_notes' /* 直播备注 */)" class="mb10">
                        <tinymceEditor v-decorator="['live_notes']" :type="2" :height="300"></tinymceEditor>
                    </a-form-item>
                </a-col>

                <a-col :xs="24">
                    <a-form-item :label="$t('program.session_label' /* Session标签 */)" class="mb10">
                        <a-input autocomplete="off" :placeholder="$t('program.session_label' /* Session标签 */)" v-decorator="['label']" />
                        <p slot="extra" class="error-color">{{ $t('program.session_label_tip' /* 用于在PC和移动端日程Session标题后显示 */) }}</p>
                    </a-form-item>
                </a-col>

                <a-col :xs="24">
                    <a-form-item :label="$t('program.session_contact' /* Session负责人 */)" class="mb10">
                        <a-input autocomplete="off" :placeholder="$t('program.session_contact' /* Session负责人 */)" v-decorator="['contacts']" />
                    </a-form-item>
                </a-col>

                <a-col :xs="24">
                    <a-form-item :label="$t('program.session_contact_tel' /* Session负责人电话 */)" class="mb10">
                        <a-input autocomplete="off" :placeholder="$t('program.session_contact_tel' /* Session负责人电话 */)" v-decorator="['contacts_tel']" />
                    </a-form-item>
                </a-col>

                <template v-if="form.getFieldValue('is_satellite')">
                    <a-col :xs="24">
                        <a-form-item :label="$t('program.satellite_display_image' /* 专题会展示图片 */)" class="mb10">
                            <a-upload
                                list-type="picture-card"
                                class="avatar-uploader"
                                :show-upload-list="false"
                                :action="uploadImageUrl"
                                :data="{ type: 1 }"
                                :before-upload="beforeUpload"
                                :headers="uploadHeaders"
                                @change="handleChange($event, { fieldName: 'image', loading: 'loading_image' })"
                            >
                                <input type="hidden" v-decorator="['image', { rules: [{ required: true, message: $t('program.please_upload_image' /* 请上传图片 */) }] }]" />
                                <a-spin v-if="form.getFieldValue('image')" :spinning="loading_image">
                                    <img style="max-width: 100%" :src="form.getFieldValue('image') | urlFilter(250)" alt="file" />
                                </a-spin>
                                <div v-else>
                                    <a-icon :type="loading_image ? 'loading' : 'plus'" />
                                    <div class="ant-upload-text">{{ $t('program.upload_image' /* 上传图片 */) }}</div>
                                </div>
                            </a-upload>
                            <a-button @click="handleRemoveEvent('image')" v-if="form.getFieldValue('image')">{{ $t('web.clear' /* 清 除 */) }}</a-button>
                            <div slot="extra" class="error-color">
                                <p class="mb5">{{ $t('program.satellite_display_image_tip' /* 建议尺寸950*150px ，支持JPG,GIF,PNG图片文件,文件大小：≤500kb */) }}</p>
                                <p>{{ $t('program.satellite_display_image_usage' /* 用于直播页卫星会tab展示 */) }}</p>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24">
                        <a-form-item :label="$t('program.satellite_company_logo' /* 专题会企业Logo */)" class="mb10">
                            <a-upload
                                list-type="picture-card"
                                class="avatar-uploader"
                                :show-upload-list="false"
                                :action="uploadImageUrl"
                                :data="{ type: 1 }"
                                :before-upload="beforeUpload"
                                :headers="uploadHeaders"
                                @change="handleChange($event, { fieldName: 'logo', loading: 'loading_logo' })"
                            >
                                <input type="hidden" v-decorator="['logo', { rules: [{ required: true, message: $t('program.please_upload_image' /* 请上传图片 */) }] }]" />
                                <a-spin v-if="form.getFieldValue('logo')" :spinning="loading_logo">
                                    <img style="max-width: 100%" :src="form.getFieldValue('logo') | urlFilter(250)" alt="file" />
                                </a-spin>
                                <div v-else>
                                    <a-icon :type="loading_logo ? 'loading' : 'plus'" />
                                    <div class="ant-upload-text">{{ $t('program.upload_image' /* 上传图片 */) }}</div>
                                </div>
                            </a-upload>
                            <a-button @click="handleRemoveEvent('logo')" v-if="form.getFieldValue('logo')">{{ $t('web.clear' /* 清 除 */) }}</a-button>
                            <div slot="extra" class="error-color">
                                <p class="mb5">{{ $t('program.satellite_display_image_tip' /* 建议尺寸950*150px ，支持JPG,GIF,PNG图片文件,文件大小：≤500kb */) }}</p>
                                <p>{{ $t('program.satellite_display_image_usage' /* 用于直播页卫星会tab展示 */) }}</p>
                            </div>
                        </a-form-item>
                    </a-col>
                </template>
            </a-row>
        </a-form>
        <div
            class="t-r"
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '50px',
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 99
            }"
        >
            <a-button type="default" @click="visible = false">{{ $t('web.cancel' /* 取消 */) }}</a-button>
            <a-button :loading="loading" :disabled="loading" class="ml10" type="primary" @click="handleSubmitEvent(0)">{{ $t('web.save' /* 保存 */) }}</a-button>
        </div>
    </a-drawer>
</template>

<script>
import moment from 'moment';
import userApi from '@/request/apiList';
import colorSelect from '@/components/color-select.vue';
import { display_mode, live_source } from '@/config/const';
import tinymceEditor from '@/components/Tinymce/index.vue';
const fields = [
    'customid',
    'date_id',
    'hall_id',
    'xuezu_id',
    'activity_id',
    'starttime_slot',
    'endtime_slot',
    'orderbyid',
    'timelength',
    'is_change_timelength',
    'abstract_title',
    'abstract_title_en',
    'hall_language',
    'session_introduction',
    'session_introduction_en',
    'display_cnmode',
    'display_enmode',
    'colour',
    'is_satellite',
    'team_id',
    'is_sync_program',
    'live_source',
    'live_id',
    'live_url',
    'live_notes',
    'label',
    'contacts',
    'contacts_tel',
    'image',
    'logo'
];
import pick from 'lodash.pick';
export default {
    name: 'SessionUpdateDrawer',
    components: { tinymceEditor, colorSelect },
    props: {
        xuezuList: {
            type: Array,
            default: []
        },
        dateList: {
            type: Array,
            default: []
        },
        hallList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            visible: false,
            display_mode,
            live_source,
            loading: false,
            // 枚举列表
            enuInfo: [],
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            loading_image: false,
            loading_logo: false,
            form: this.$form.createForm(this)
        };
    },
    computed: {},
    methods: {
        show(info) {
            this.visible = true;
            if (info) {
                info = JSON.parse(JSON.stringify(info));
                this.$nextTick(() => {
                    fields.forEach(v => this.form.getFieldDecorator(v));
                    info.customid = info.id;
                    if (info.starttime_slot) {
                        info.starttime_slot = moment(info.starttime_slot, 'HH:mm');
                    }
                    if (info.endtime_slot) {
                        info.endtime_slot = moment(info.endtime_slot, 'HH:mm');
                    }
                    info.is_change_timelength = info.is_change_timelength == 'on' ? true : false;
                    info.is_satellite = info.is_satellite == 1 ? true : false;
                    info.is_sync_program = info.is_sync_program == 1 ? true : false;

                    this.form.setFieldsValue(pick(info, fields));
                });
            }
            if (Object.keys(this.enuInfo).length == 0) {
                this.getProgramEnuList();
            }
        },
        // 获取枚举列表
        getProgramEnuList() {
            this.$request.get({ url: 'getProgramEnuList' }).then(res => {
                this.enuInfo = res.data;
            });
        },
        //关闭弹窗
        handleDrawerClose() {
            this.form.resetFields();
            this.visible = false;
        },
        // 禁用时间
        disabledHours() {
            let start_time = this.form.getFieldValue('starttime_slot');
            if (start_time) {
                let start_hour = start_time.hours();
                const hours = [];
                for (let i = 0; i < start_hour; i++) {
                    hours.push(i);
                }
                return hours;
            }
            return [];
        },
        // 禁用分钟
        disabledMinutes(hours, minutes) {
            let start_time = this.form.getFieldValue('starttime_slot');
            if (start_time) {
                let start_hour = start_time.hours();
                if (hours > start_hour) {
                    return [];
                }
                let start_minutes = start_time.minutes();
                const minutes = [];
                for (let i = 0; i < start_minutes; i++) {
                    minutes.push(i);
                }
                return minutes;
            }
            return [];
        },

        // 删除
        handleRemoveEvent(field) {
            this.form.setFieldsValue({ [field]: '' });
        },

        // 上传修改
        handleChange(info, { fieldName, loading }) {
            if (info.file.status === 'uploading') {
                this[loading] = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    let obj = {};
                    obj[fieldName] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                this[loading] = false;
            }
        },

        // 上传前
        beforeUpload(file) {
            return new Promise((resolve, reject) => {
                // 头像的验证
                let regFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
                if (!regFile) {
                    this.$message.error(this.$t('formConfig.only_upload_image' /* 您只能上传图像文件 */));
                    return reject(regFile);
                }
                return resolve(regFile);
            });
        },
        // 开始时间
        handleStartTimeChange(value, a) {
            let endtime_slot = moment(value).add(this.form.getFieldValue('timelength'), 'minutes');
            this.form.setFieldsValue({ endtime_slot });
        },
        // 结束时间
        handleEndTimeChange(value) {
            let starttime_slot = this.form.getFieldValue('starttime_slot');
            if (starttime_slot) {
                var duration = moment.duration(value.diff(starttime_slot));
                // 获取相差的分钟数
                var timelength = duration.asMinutes();
                this.form.setFieldsValue({ timelength });
            }
        },
        // 时长改变事件
        handleTimeLongChange(value) {
            let starttime_slot = this.form.getFieldValue('starttime_slot');
            if (starttime_slot) {
                let endtime_slot = moment(starttime_slot).add(value, 'minutes');
                this.form.setFieldsValue({ endtime_slot });
            }
        },
        // 表单请求接口
        handleSubmitEvent(continues) {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true;
                    values['continues'] = continues;
                    if (values.starttime_slot._isAMomentObject) {
                        values.starttime_slot = values.starttime_slot.format('HH:mm');
                    }
                    if (values.endtime_slot._isAMomentObject) {
                        values.endtime_slot = values.endtime_slot.format('HH:mm');
                    }
                    values.is_change_timelength = values.is_change_timelength ? 'on' : '';
                    values.is_satellite = values.is_satellite ? 1 : 0;
                    values.is_sync_program = values.is_sync_program ? 1 : 0;

                    this.$request
                        .post({ url: 'updateProgramSession', data: values, costom: { hideModal: true } })
                        .then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.message);
                                this.$emit('refresh');
                                this.handleDrawerClose();
                            } else if (res.code == 100002) {
                                this.$confirm({
                                    title: this.$t('web.tips' /* 温馨提示 */),
                                    content: res.message,
                                    onOk: () => {
                                        // 1不验证时间段冲突，继续发起请求
                                        this.handleSubmitEvent(1);
                                    }
                                });
                            }
                        })
                        .catch(err => {
                            console.log(err);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.form.validateFieldsAndScroll();
                }
            });
        }
    },
    created() {},
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    }
};
</script>
<style lang="less" scoped>
.session-form {
    overflow: hidden;
    /deep/.ant-form-item-label {
        line-height: 2;
    }
}
</style>
